import type { IconSvgObject } from './types';

const WordpressIcon: IconSvgObject = [
  ["path", { d: "M2 6.5H3M3 6.5L8 20.5L10 16.5M3 6.5H6.5M6.5 6.5H7.5M6.5 6.5L10 16.5M10 16.5L12.5 11.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M10 6.5H11M11 6.5L16 20.5L18 17M11 6.5H14.5M14.5 6.5H15.5M14.5 6.5L18 17M18 17L20.5288 12.144M20.5288 12.144L21.5377 9.73491C21.9415 8.62432 22.0835 7.43739 21.9529 6.26443C21.7963 4.85795 21.1576 3.5 19.5012 3.5C17.9632 3.5 17.2101 5.22272 18.1898 6.39363C19.7701 8.28249 21.1719 10.3754 20.5288 12.144Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default WordpressIcon;
